import React, { useEffect } from 'react';
import { get } from 'global/lib/lodash';
import { userHasPermissions } from 'redux/actions/userLogin';
import useNavSettings from '../../hooks/useNavSettings';

export default (Component) => (props) => {
  const { requiredNav } = props;
  const { nav } = useNavSettings();

  useEffect(() => {
    const allowedPermissions = get(props, 'allowedPermissions');
    if (!userHasPermissions(allowedPermissions)) {
      alert('You do not have permission to be here. Redirecting you home.');
      window.location.href = '/home';
    }
  }, [props.allowedPermissions]);

  useEffect(() => {
    if (requiredNav && !get(nav, requiredNav)) {
      alert('You do not have permission to be here. Redirecting you home.');
      window.location.href = '/home';
    }
  }, [nav, requiredNav]);

  return <Component {...props} />;
};
